import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  House,
  Users,
  Briefcase,
  Invoice,
  Gear,
  Cube,
  Blueprint,
  SealPercent,
  Megaphone,
  AppWindow,
  SquaresFour,
  CaretRightIcon, 
  CaretLeftIcon,
  PuzzlePieceIcon
} from "@phosphor-icons/react";
import styles from "./style.module.scss";
import optenicsLogo from '../../assets/optenics_logo.png';
import optenicsLogoIcon from '../../assets/optenics_ml_icon.png';
import optenicsLogoText from '../../assets/optenics_ml_text.png';

interface SidebarProps {
  isExpanded: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isExpanded, toggleSidebar }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const isExactPath = (path: string) => pathname === path;
  const isActive = (match: string) => pathname.startsWith(match);

  return (
    <div className={`${styles.sidebar} ${isExpanded ? styles.expanded : styles.collapsed}`}>
      {/* 🔹 Top: Applications Icon */}
      <div className={styles.profileSection}>
        <ul>
          <li>
            <Link to="/dashboard" className={styles.profileIconItem}>
             <img src={optenicsLogoIcon} alt="Optenics" className={styles.navlogoIcon}/>
              {/* <SquaresFour className={styles.profileIcon} /> */}
              {isExpanded && <span className={styles.profileLabel}>
                <img src={optenicsLogoText} alt="Optenics" className={styles.navlogoText}/>
                </span>}
            </Link>
          </li>
        </ul>
      </div>

      {/* 🔹 Main Navigation Items */}
     <ul className={styles.navItems}>
  {/* Dashboard */}
  <li className={styles.navItem}>
    <Link
      to="/dashboard"
      className={`${styles.navLink} ${isExactPath("/dashboard") ? styles.active : ""}`}
      title={!isExpanded ? "Dashboard" : undefined}
    >
      <House className={styles.icon} />
      {isExpanded && <span className={styles.label}>Dashboard</span>}
    </Link>
  </li>

  {/* Users */}
  <li className={styles.navItem}>
    <Link
      to="/users"
      className={`${styles.navLink} ${isActive("/users") ? styles.active : ""}`}
      title={!isExpanded ? "Users" : undefined}
    >
      <Users className={styles.icon} />
      {isExpanded && <span className={styles.label}>Users</span>}
    </Link>
  </li>

  {/* Organizations */}
  <li className={styles.navItem}>
    <Link
      to="/organizations"
      className={`${styles.navLink} ${isActive("/organizations") ? styles.active : ""}`}
      title={!isExpanded ? "Organizations" : undefined}
    >
      <Briefcase className={styles.icon} />
      {isExpanded && <span className={styles.label}>Orgs</span>}
    </Link>
  </li>

  {/* Roles & Access */}
  <li className={styles.navItem}>
    <Link
      to="/roles"
      className={`${styles.navLink} ${isActive("/roles") ? styles.active : ""}`}
      title={!isExpanded ? "Roles" : undefined}
    >
      <Gear className={styles.icon} />
      {isExpanded && <span className={styles.label}>Roles</span>}
    </Link>
  </li>

  {/* Apps (from optenics.app) */}
  <li className={styles.navItem}>
    <Link
      to="/apps"
      className={`${styles.navLink} ${isActive("/apps") ? styles.active : ""}`}
      title={!isExpanded ? "Apps" : undefined}
    >
      <AppWindow className={styles.icon} />
      {isExpanded && <span className={styles.label}>Apps</span>}
    </Link>
  </li>

  {/* Connections (org ↔ org linking) */}
  <li className={styles.navItem}>
    <Link
      to="/connections"
      className={`${styles.navLink} ${isActive("/connections") ? styles.active : ""}`}
      title={!isExpanded ? "Connections" : undefined}
    >
      <PuzzlePieceIcon className={styles.icon} />
      {isExpanded && <span className={styles.label}>Connections</span>}
    </Link>
  </li>

  {/* System Settings */}
  {/* <li className={styles.navItem}>
    <Link
      to="/system"
      className={`${styles.navLink} ${isActive("/system") ? styles.active : ""}`}
      title={!isExpanded ? "System" : undefined}
    >
      <Gear className={styles.icon} />
      {isExpanded && <span className={styles.label}>System</span>}
    </Link>
  </li> */}
</ul>


      {/* 🔹 Sidebar Toggle Button */}
     <button
    className={`${styles.toggleButton} ${isExpanded ? styles.expandedToggle : ""}`}
    onClick={toggleSidebar}
    aria-label="Toggle Sidebar"
  >
    {isExpanded ? <CaretLeftIcon size={14} weight="bold" color="#1f2937" /> : <CaretRightIcon size={14} weight="bold" color="#1f2937"/>}
  </button>
    </div>
  );
};

export default Sidebar;
